import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { Modal } from "antd";

import { resetOtherCoinsState } from "../../redux/analyze-other-coins/otherCoinsAnalyzeSlice";
import useServiceStatus from "../../hooks/useServiceStatus";
import OtherCoinsConfigs from "./OtherCoinsConfigs";
import OtherCoinsResult from "./OtherCoinsResult";

function OtherCoins({
  btnTitle,
  disabledCoins = [],
  btnStyle = {},
  // active,
  children,
  className = "",
}) {
  const [openModal, setOpenModal] = useState(false);

  const { isActive } = useServiceStatus("aiAssistant");

  const clickHandler = () => {
    if (!isActive) return;

    setOpenModal(true);
  };

  return (
    <>
      <span
        className={`${className} 
        
        `}
        style={btnStyle}
        onClick={clickHandler}
      >
        {children || btnTitle || <FaPlus />}
      </span>

      {openModal && (
        <OtherCoinsModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          disabledCoins={disabledCoins}
        />
      )}
    </>
  );
}

export default OtherCoins;

function OtherCoinsModal({ open, onClose, disabledCoins }) {
  const {
    otherCoinsAnalyze: { status },
  } = useSelector((state) => state);

  const [selectedExchange, setSelectedExchange] = useState("");
  const [selectedSymbols, setSelectedSymbols] = useState([]);
  const [searchedCoin, setSearchedCoin] = useState("");

  const [selectedWatchlist, setSelectedWatchlist] = useState("all");

  const [step, setStep] = useState(1);

  const dispatch = useDispatch();

  const controllerRef = useRef(null);
  const openSettingsRef = useRef(null);

  const closeModal = () => {
    if (status === "loading") {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    }

    setSelectedExchange("");
    setSelectedSymbols([]);
    dispatch(resetOtherCoinsState());
    onClose();
  };

  const handleExchangeChange = (exchange) => {
    if (status === "error") {
      dispatch(resetOtherCoinsState());
    }
    openSettingsRef.current = null;
    setSelectedExchange(exchange);
    setSelectedSymbols([]);
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={closeModal}
        centered
        footer={null}
        title={step === 1 ? "Get other coins signal" : ""}
        maskClosable={false}
      >
        {step === 1 && (
          <OtherCoinsConfigs
            handleExchangeChange={handleExchangeChange}
            searchedCoin={searchedCoin}
            setSearchedCoin={setSearchedCoin}
            selectedExchange={selectedExchange}
            selectedSymbols={selectedSymbols}
            setSelectedSymbols={setSelectedSymbols}
            selectedWatchlist={selectedWatchlist}
            setSelectedWatchlist={setSelectedWatchlist}
            setStep={setStep}
            controllerRef={controllerRef}
          />
        )}
        {step === 2 && <OtherCoinsResult selectedExchange={selectedExchange} controllerRef={controllerRef} />}
      </Modal>
    </>
  );
}

{
  /*<Select*/
}
{
  /*  style={{ width: "100%" }}*/
}
{
  /*  ref={symbolsInputRef}*/
}
{
  /*  placeholder="Select a coin"*/
}
{
  /*  value={selectedSymbols}*/
}
{
  /*  onChange={handleSymbolChange}*/
}
{
  /*  showSearch*/
}
{
  /*  optionFilterProp="children"*/
}
{
  /*  filterOption={(input, option) =>*/
}
{
  /*    (option?.value ?? "").toLowerCase().includes(input.toLowerCase())*/
}
{
  /*  }*/
}
{
  /*  mode="multiple"*/
}
{
  /*  disabled={*/
}
{
  /*    !allExchangesWithCoins?.length &&*/
}
{
  /*    allExchangesWithCoinsStatus !== "success"*/
}
{
  /*  }*/
}
{
  /*  className={styles.coinSelector}*/
}
{
  /*>*/
}
{
  /*  {coinsStatus === "loading" ? (*/
}
{
  /*    <Select.Option disabled>Loading...</Select.Option>*/
}
{
  /*  ) : assets.length > 0 ? (*/
}
{
  /*    assets?.map((asset) => (*/
}
{
  /*      <Select.Option*/
}
{
  /*        key={asset}*/
}
{
  /*        value={asset}*/
}
{
  /*        className={`${styles.option}`}*/
}
{
  /*      >*/
}
{
  /*        <LazyLoadImage*/
}
{
  /*          src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${asset}.png`}*/
}
{
  /*          alt={asset}*/
}
{
  /*          width="25px"*/
}
{
  /*          height="25px"*/
}
{
  /*          effect="blur"*/
}
{
  /*          style={{ borderRadius: "50%" }}*/
}
{
  /*          onError={(e) => {*/
}
{
  /*            e.target.onerror = null;*/
}
{
  /*            e.target.src = "/placeholders/asset-logo.svg";*/
}
{
  /*          }}*/
}
{
  /*        />*/
}
{
  /*        <span>{asset}/USDT</span>*/
}
{
  /*      </Select.Option>*/
}
{
  /*    ))*/
}
{
  /*  ) : (*/
}
{
  /*    <Select.Option disabled className={styles.emptyOption}>*/
}
{
  /*      <Empty imageStyle={{ width: "80px", height: "60px" }} />*/
}
{
  /*    </Select.Option>*/
}
{
  /*  )}*/
}
{
  /*</Select>*/
}

// ${
//   disabledCoins?.includes(
//       asset?.split("/")?.[0]?.toLowerCase(),
//   )
//       ? styles.hasSignal
//       : ""
// }
